import { render, staticRenderFns } from "./homeC.vue?vue&type=template&id=741c3d08&"
import script from "./homeC.vue?vue&type=script&lang=js&"
export * from "./homeC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports